export const pgSyncMonitoringStyles = {
  container: { height: '100vh' },
};
